import { useState, useEffect } from 'react';
import { Container, Card, Table, Spinner, Badge } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { getMyWallets, getMyTransactions } from '../../api/walletApi';

const Wallet = () => {
  const [wallets, setWallets] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  const isEarning = searchParams.get('type') === 'earning';
  const walletKey = isEarning ? 'earning_wallet' : 'main_wallet';
  const walletLabel = isEarning ? 'Earning Wallet' : 'Main Wallet';
  const walletType = isEarning ? 'earning' : 'main';

  useEffect(() => {
    Promise.all([
      getMyWallets(),
      getMyTransactions(walletType),
    ])
      .then(([walletsRes, txnRes]) => {
        setWallets(walletsRes.data.wallets);
        setTransactions(txnRes.data.transactions);
      })
      .finally(() => setLoading(false));
  }, [walletType]);

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;

  const wallet = wallets?.[walletKey];

  return (
    <Container className="mt-4">
      <h4>{walletLabel}</h4>
      <Card className="p-3 shadow-sm mb-4" style={{ maxWidth: '300px' }}>
        <div className="text-muted small">USDT Balance</div>
        <h3 className="fw-bold" style={{ color: 'var(--cyan)', textShadow: '0 0 18px rgba(0,229,255,0.35)' }}>{wallet?.balance ?? 0}</h3>
      </Card>

      <h6 className="text-muted">Transaction History</h6>
      <Card className="shadow-sm">
        <Table responsive hover className="mb-0">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
            {transactions.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center text-muted py-4">No transactions yet</td>
              </tr>
            ) : (
              transactions.map((txn) => (
                <tr key={txn._id}>
                  <td>{new Date(txn.createdAt).toLocaleString()}</td>
                  <td>
                    <Badge bg={txn.txnType === 'credit' ? 'success' : 'danger'}>
                      {txn.txnType}
                    </Badge>
                  </td>
                  <td>{txn.amount} USDT</td>
                  <td>{txn.comments || '—'}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card>
    </Container>
  );
};

export default Wallet;
